import { ReactNode } from "react";
import RevealOnScroll from "@/components/ui/RevealOnScroll";

export default function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="pt-28 md:pt-36 pb-24 min-h-dvh">
      <div className="nm-container max-w-3xl">
        <RevealOnScroll>
          <h1 className="font-display text-4xl md:text-5xl font-semibold text-white">
            {title}
          </h1>
          <p className="mt-3 text-sm text-[var(--nm-ink-muted)]">
            Last updated {updated}
          </p>
        </RevealOnScroll>

        <div className="mt-10 space-y-8 text-[var(--nm-ink-muted)] leading-relaxed [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-white [&_h2]:mb-3 [&_p]:mb-3 [&_li]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_a]:text-white [&_a]:underline [&_a]:underline-offset-4">
          {children}
        </div>
      </div>
    </div>
  );
}
